<template>
<div class="container admin-table-page">
<!-- <div class="container admin-users-page"> -->
	<!-- Header con botón de retroceso y título alineados correctamente -->
	<div class="param-title-wrap d-flex align-items-center">
		<b-button class="page-back-btn mr-2" variant="link" @click="goBack">
			<font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" class="back-icon" />
		</b-button>
		<h2 >{{labels.title}}</h2>
	</div>


	<!-- Tabla SIEMPRE visible -->
	<div class="admin-table-block mt-4">
		<CorporateDataTable 
			:items="saldosTableItems"
			:fields="allFields"
			:filter-defs="tableFilterDefs"
			:labels="tableLabels"
			:default-per-page="10"
			:page-options="[10, 20, 50, 100]"
			:narrow="false"
			:table-min-height="500"
			:table-max-height="500"
			:show-search="true"
			:allow-column-toggle="true"
			:enable-sorting="true"
			:toolbar-disabled="false"
			:showExportButton="true"
			:exportButtonText="'Excel'"
			:exportReportTitle= "'INGRESOS'"
			:exportSubtitle="this.labelsExcel"
			:exportExcludeFields="['info','edit','contab','dec','estado','check']"
			:exportUseFiltered="true"
			:exportFileName="'INGRESOS'"
		>
			<template #toolbar-actions>
				<b-button v-if="fgl_crear" size="sm" class="table-toolbar-add-btn" >
					{{ labels.create }} 
				</b-button>
			</template>
		</CorporateDataTable>
		
		<!-- Loading -->
		<div v-if="isLoading" class="text-center py-5">
			<b-spinner></b-spinner>
			<p class="mt-2">{{ labels.loading }}</p>
		</div>
		
	</div>
</div>
</template>

<script>
import Saldos from "@/services/Saldos";
import CorporateDataTable from "../utils/CorporateDataTable.vue"

export default {
name: "List",
components: {
	CorporateDataTable,
},
data: () => ({
	isLoading: true,
	fgl_crear : false,
	saldos: [],	
}),
computed: {
labelsExcel() {
	return "Saldos"
},
labels() {
      if (this.$store.state._language == "es-ES") {
        return {
		title: "Saldos",
		saldos: "Saldos",
        };
      } else {
        return {
		title: "Saldos",
		saldos: "Saldos",
        }
      }
},
saldosTableItems() {
      return (this.saldos || []).map((item) => ({
		...item, 
      }));
},
allFields() {
	return [
		{ key: 'cuenta', label: this.labels.divipol, sortable: true },
		{ key: 'descripcion', label: this.labels.descripcion, sortable: true, tdClass: 'nowrap-cell'},
		{ key: 'municipio', label: this.labels.municipio, sortable: true, tdClass: 'nowrap-cell'},
		{ key: 'nit_movimiento', label: this.labels.nit_movimiento, sortable: true, tdClass: 'nowrap-cell'},
		{ key: 'nombre_movimiento', label: this.labels.nombre_movimiento, sortable: true, tdClass: 'nowrap-cell'},
		{ key: 'movimiento', label: this.labels.movimiento, sortable: true, tdClass: 'nowrap-cell'},
	];
},
tableFilterDefs() {
	return [
		{ key: 'createdAt', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar Fecha Ingreso...' : 'Filter Date...' },
		{ key: 'identificacion', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar Nit...' : 'Filter Nit...' },
		{ key: 'nombre', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar Proveedor...' : 'Filter Proveedor...' },
		{ key: 'factura', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar Factura...' : 'Filter Invoice...' },
		{ key: 'fecha_factura', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar Fecha...' : 'Filter Date...' },
		{ key: 'nombre_analista', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar Analista...' : 'Filter Analyst...' },
	];
},
tableLabels() {
return {
        noRow: this.labels.empty,
        noMatches: this.$store.state._language == "es-ES" ? "No se encontraron resultados" : "No results found",
        searchPlaceholder: this.$store.state._language == "es-ES" ? "Buscar en la tabla..." : "Search in table...",
        rowsPerPage: this.$store.state._language == "es-ES" ? "Filas por página:" : "Rows per page:",
        noSort: this.$store.state._language == "es-ES" ? "Sin orden" : "No sorting",
        sortAsc: this.$store.state._language == "es-ES" ? "A-Z / Menor a mayor" : "A-Z / Low to high",
        sortDesc: this.$store.state._language == "es-ES" ? "Z-A / Mayor a menor" : "Z-A / High to low",
        columns: this.$store.state._language == "es-ES" ? "Columnas" : "Columns",
        showAllColumns: this.$store.state._language == "es-ES" ? "Mostrar todas" : "Show all",
        filters: this.$store.state._language == "es-ES" ? "Filtros" : "Filters",
        clearFilters: this.$store.state._language == "es-ES" ? "Limpiar filtros" : "Clear filters",
      };
},
},

methods: {
goBack() {
        this.$router.back()
},
cierraModal(val){
	if	(val) {
		const indice = this.facturas.findIndex(fila => fila.id === this.InfoFactura.id);
		if	(indice !== -1) {
			if	(this.$route.name=='facbposinasignar' && this.InfoFactura.estado == 1) {
				this.facturas.splice(indice,1)
			} else {
				this.facturas.splice(indice,1)
			}
		}
	}
	this.fglEvento=false
	this.fglCrear=false
	this.fglEditar=false
	this.fglShow=false
	this.fglContabiliza=false
	this.fglEstado=false
	this.fglTabla=true
},


confirmaEvento(val) {
	if (!val) return; 

},
fechaFormat(fecha){
	let year = fecha.slice(6) 
	let month = fecha.slice(3,-5) 
	let day = fecha.slice(0,-8) 
	return year+'-'+month+'-'+day
},
variableHijo(val){
	if(val.length != 0){ 
		this.searched = val;
		this.facturasList = val;
		this.getDataPagina(1);
		this.totalPaginas()
	}else{
		this.msjSinReg
	}
},
},
mounted() {
	this.isLoadingCarga = true;
	this.isLoading = true;
	Promise.all([ Saldos.leaSaldos() ])
	.then(([saldosRes]) => { 
		this.saldos = saldosRes.data.saldos || [];
		this.isLoading = false;
	})
	.catch((e) => { 
		console.log("Error: "+e);
		this.error = true;
		this.isLoading = false;
	});
},
}
</script>

<style src="../main.css"></style>
<style scoped src="../filtros.css"></style>

